"use client";

import styled from "@emotion/styled";

import { Button } from "../../../atoms/Button";
import { colors } from "../../../design-tokens/colors";
import { sizes } from "../../../design-tokens/dimensions";
import { typography } from "../../../design-tokens/typography";
import { ButtonGroup } from "../ButtonGroup";

export const Footer = styled.footer`
  align-items: start;
  display: flex;
  flex-flow: column nowrap;
  margin-left: 0;
  margin-top: auto;
`;

export const ModalTabButton = styled(Button)<{ isCurrent: boolean }>`
  align-items: start;
  background-color: ${({ isCurrent }) => (isCurrent ? colors.blue : "inherit")};
  color: ${({ isCurrent }) => (isCurrent ? colors.baseBlack : colors.white)};
  cursor: pointer;
  font-weight: ${typography.weights.normal};
  height: auto;
  justify-content: left;
  line-height: ${sizes.s24.rem};
  margin: 0;
  min-width: auto;
  padding: ${sizes.s4.rem} ${sizes.s8.rem};
  white-space: nowrap;
`;

export const Root = styled.div`
  align-items: start;
  border-right: 1px solid ${colors.baseMid};
  display: flex;
  flex-flow: column nowrap;
  justify-content: space-between;
  margin: 0 ${sizes.s16.rem} 0 0;
  min-width: ${sizes.s192.rem};
  padding-right: ${sizes.s16.rem};
`;

export const SidebarButtonGroup = styled(ButtonGroup)`
  align-items: flex-start;
  container: auto;
  flex: auto;
  margin-bottom: ${sizes.s12.rem};
`;
